// Environment configuration mapping
const ENV_CONFIG = {
  'https://pcs-dev.pixl.ai': {
    appVersion: 'v2.2.0',
  },
  'https://pcs-uat.pixl.ai': {
    appVersion: 'v2.2.0',
  },
  'https://pcs.pixl.ai': {
    appVersion: 'v2.2.0',
  },
};

export default ENV_CONFIG;
